var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }
import Component from '@glimmer/component';
import { equal } from 'macro-decorators';
export let DEVICE_STATUS;
(function (DEVICE_STATUS) {
  DEVICE_STATUS["ONLINE"] = "online";
  DEVICE_STATUS["OFFLINE"] = "offline";
  DEVICE_STATUS["NOT_PAIRED"] = "not-paired";
  DEVICE_STATUS["INSUFFICIENT_PERMISSIONS"] = "insufficient-permissions";
  DEVICE_STATUS["OPERATIONAL"] = "operational";
  DEVICE_STATUS["OUT_OF_CASE"] = "out-of-case";
  DEVICE_STATUS["LOW_VOLUME"] = "volume_low";
})(DEVICE_STATUS || (DEVICE_STATUS = {}));
let RoombaStatusBadge = (_dec = equal('args.status', DEVICE_STATUS.ONLINE), _dec2 = equal('args.status', DEVICE_STATUS.OFFLINE), _dec3 = equal('args.status', DEVICE_STATUS.NOT_PAIRED), _dec4 = equal('args.status', DEVICE_STATUS.INSUFFICIENT_PERMISSIONS), _dec5 = equal('args.status', DEVICE_STATUS.OPERATIONAL), _dec6 = equal('args.status', DEVICE_STATUS.OUT_OF_CASE), _dec7 = equal('args.status', DEVICE_STATUS.LOW_VOLUME), (_class = class RoombaStatusBadge extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "online", _descriptor, this);
    _initializerDefineProperty(this, "offline", _descriptor2, this);
    _initializerDefineProperty(this, "notPaired", _descriptor3, this);
    _initializerDefineProperty(this, "insufficientPermissions", _descriptor4, this);
    _initializerDefineProperty(this, "operational", _descriptor5, this);
    _initializerDefineProperty(this, "outOfCase", _descriptor6, this);
    _initializerDefineProperty(this, "volumeLow", _descriptor7, this);
  } // Device statuses
  get count() {
    return this.args.count === undefined ? '' : `${this.args.count} `;
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "online", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "offline", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "notPaired", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "insufficientPermissions", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "operational", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "outOfCase", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "volumeLow", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class));
export { RoombaStatusBadge as default };